var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrintBatchLoadExpBarcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H0.5H5V1H1V5H0V0.5V0ZM24 24H23.5H19V23H23V19H24V23.5V24ZM23.5 0H24V0.5V5H23V1H19V0H23.5ZM0 24H0.5H5V23H1V19H0V23.5V24ZM5 3H3V21H5V3ZM6 3H9V21H6V3ZM11 3H10V21H11V3ZM12 3H13V21H12V3ZM16 3H14V21H16V3ZM17 3H19V21H17V3ZM21 3H20V21H21V3Z",
    fill: "#26572B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrintBatchLoadExpBarcode);
export default __webpack_public_path__ + "static/media/PrintBatchLoadExpBarcode.cd5b7a9f781859cb797b301ac61407ec.svg";
export { ForwardRef as ReactComponent };